import { Button, Container, Stack } from "react-bootstrap";
import { ENTRA, KEYCLOAK, selectProvider } from "./utils/auth";

const ProviderLabels = {
  [ENTRA]: "Sign in with Microsoft",
  [KEYCLOAK]: "Sign in with Keycloak",
};

const LoginChooser = ({ providers }) => {
  const handleSelect = (name) => {
    selectProvider(name);
    window.location.reload();
  };

  return (
    <Container className="my-5" style={{ maxWidth: 360 }}>
      <h2 className="text-center mb-4">Tournaments Admin</h2>
      <Stack gap={3}>
        {providers.map((name) => (
          <Button
            key={name}
            variant={name === ENTRA ? "primary" : "outline-secondary"}
            size="lg"
            onClick={() => handleSelect(name)}
          >
            {ProviderLabels[name] ?? name}
          </Button>
        ))}
      </Stack>
    </Container>
  );
};

export default LoginChooser;
